import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from "axios";
import isEmpty from "lodash/isEmpty";

// CSS
import '../../../css/social_media.css'

// Components
import Loader from '../../utils/Loader';
import AdminSocialMediaField from './AdminSocialMediaField';

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class AdminSocialMedia extends Component {
    constructor(props){
        super(props)
        this.state = {
            errors: {},
            loading: false,
            updateLoading: false,
            success: '',
            facebook: '',
            twitter: '',
            instagram: ''
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Social Media')
    }

    componentDidMount(){
        this.getSocialMedia();
    }

    handleInputChange = (value, type) => {
        this.setState({
            [type]: value
        })
    }

    getSocialMedia = () => {
        const {user} = this.props;

        this.setState({
            loading: true
        }, () => {
            const token = user.token;
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

            return axios
                .get(REACT_APP_API_URL + "social-media", { headers: AUTH_HEADER })
                .then(response => {
                    if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                        // this.props.userLogout("admin");
                    } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                        this.setState({ loading: false, error: response.data.message });
                    } else {
                        this.setSocialMedia(response.data.socials);
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.setState({ loading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                    } else {
                        this.setState({ loading: false, error: err.message });
                    }
                });
        })
    }

    setSocialMedia = (socials) => {
        socials.forEach(element => {
            if(element.social_media_type === 'facebook'){
                this.setState({loading: false, facebook: element.url})
            } else if (element.social_media_type === 'twitter'){
                this.setState({loading: false, twitter: element.url})
            } else {
                this.setState({loading: false, instagram: element.url})
            }
        });
    }

    updateSocialMedia = () => {
        const {user} = this.props;

        this.setState(
            {updateLoading: true},
            () => {
                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

                let params = {
                    facebook: this.state.facebook,
                    twitter: this.state.twitter,
                    instagram: this.state.instagram
                }

                return axios
                    .post(REACT_APP_API_URL + "social-media/", params, { headers: AUTH_HEADER })
                    .then(response => {
                        console.log(response)
                        if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                            userLogout("admin");
                        } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                            this.setState({ isLoading: false, error: response.data.message });
                        } else {
                            this.setState({
                                updateLoading: false,
                                success: response.data.message
                            }, () => this.getSocialMedia());
                        }
                    })
                    .catch(err => {
                        if (err.response) {
                            this.setState({ updateLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                        } else {
                            this.setState({ updateLoading: false, error: err.message });
                        }
                    });
            }
        );
    }

    render() {
        return (
            <div>
                <h1>Edit Social Media</h1>
                <div className="instruction">Enter a URL for each social media and a button will appear in the site footer linking to the inputted URL. If you'd like to hide a button, leave the input field blank.</div>
                {this.props.loading || this.state.updateLoading ? 
                <Loader/> :
                <div>
                    <AdminSocialMediaField label={'Facebook'} icon={'facebook'} value={this.state.facebook} handleInputChange={(e, type) => this.handleInputChange(e.target.value, type)}/>
                    <AdminSocialMediaField label={'Twitter'} icon={'twitter'} value={this.state.twitter} handleInputChange={(e, type) => this.handleInputChange(e.target.value, type)} />
                    <AdminSocialMediaField label={'Instagram'} icon={'instagram'} value={this.state.instagram} handleInputChange={(e, type) => this.handleInputChange(e.target.value, type)} />
                    
                    {!isEmpty(this.state.success) && <div className="success msg_animate">{this.state.success}</div>}
                    <button className="btn" onClick={() => this.updateSocialMedia()}>Update</button>
                </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, userTokenUpdate, userLogout })(AdminSocialMedia)



// WEBPACK FOOTER //
// ./src/components/admin/social-media/AdminSocialMedia.js